'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactackleCore = require('reactackle-core');

var _reactackleIcons = require('reactackle-icons');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var constants = {
  themeColor: _reactackleCore.colorSecondary,
  fontColor: _reactackleCore.bodyFontColor,
  backgroundColor: _reactackleCore.colorTransparent,
  borderStyle: 'solid',

  size: {
    paddingY: (0, _reactackleCore.bmodule)(1),
    fontSize: _reactackleCore.fontSizeBody,
    lineHeight: 1.5,
    paddingX: {
      bordered: (0, _reactackleCore.bmodule)(1),
      underlined: 0
    },

    dense: {
      paddingY: (0, _reactackleCore.bmodule)(0.5),
      fontSize: _reactackleCore.fontSizeBody,
      lineHeight: 1.5,
      paddingX: {
        bordered: (0, _reactackleCore.bmodule)(0.5),
        underlined: 0
      }
    },

    fullWidth: {
      paddingY: (0, _reactackleCore.bmodule)(1.5),
      fontSize: _reactackleCore.fontSizeBody,
      lineHeight: 1.5,
      paddingX: {
        bordered: (0, _reactackleCore.bmodule)(1.5),
        underlined: (0, _reactackleCore.bmodule)(1.5)
      }
    },

    denseFullWidth: {
      paddingY: (0, _reactackleCore.bmodule)(1.5),
      fontSize: _reactackleCore.fontSizeBody,
      lineHeight: 1.5,
      paddingX: {
        bordered: (0, _reactackleCore.bmodule)(1.5),
        underlined: (0, _reactackleCore.bmodule)(1.5)
      }
    }
  },

  underlined: {
    paddingY: (0, _reactackleCore.bmodule)(1)
  },

  iconOuter: {
    opacity: 0.54
  },

  iconInner: {
    opacity: 0.54
  }
};

exports.default = {
  textfield: {
    themeColor: constants.themeColor,
    fontFamily: _reactackleCore.bodyFontFamily,

    state: {
      fontColor: constants.fontColor,
      backgroundColor: constants.backgroundColor,
      borderColor: _reactackleCore.colorPaletteGrey300,
      borderStyle: constants.borderStyle,

      hover: {
        fontColor: constants.fontColor,
        backgroundColor: constants.backgroundColor,
        borderColor: constants.themeColor,
        borderStyle: constants.borderStyle
      },

      focus: {
        fontColor: constants.fontColor,
        backgroundColor: constants.backgroundColor,
        borderColor: constants.themeColor,
        borderStyle: constants.borderStyle
      },

      disabled: {
        fontColor: _reactackleCore.fontColorMedium,
        backgroundColor: _reactackleCore.colorTransparent,
        borderColor: _reactackleCore.colorPaletteGrey300,
        borderStyle: 'dotted'
      },

      error: {
        fontColor: _reactackleCore.colorAlert,
        backgroundColor: constants.backgroundColor,
        borderColor: _reactackleCore.colorAlert,
        borderStyle: constants.borderStyle
      },

      success: {
        fontColor: _reactackleCore.colorSuccess,
        backgroundColor: constants.backgroundColor,
        borderColor: _reactackleCore.colorSuccess,
        borderStyle: constants.borderStyle
      }
    },

    size: {
      paddingY: constants.size.paddingY,
      paddingX: constants.size.paddingX,
      lineHeight: constants.size.lineHeight,
      fontSize: constants.size.fontSize,

      dense: {
        paddingY: constants.size.dense.paddingY,
        paddingX: constants.size.dense.paddingX,
        lineHeight: constants.size.lineHeight,
        fontSize: constants.size.dense.fontSize
      },

      fullWidth: {
        paddingY: constants.size.fullWidth.paddingY,
        paddingX: constants.size.fullWidth.paddingX,
        lineHeight: constants.size.lineHeight,
        fontSize: constants.size.fullWidth.fontSize
      },

      denseFullWidth: {
        paddingY: constants.size.denseFullWidth.paddingY,
        paddingX: constants.size.denseFullWidth.paddingX,
        lineHeight: constants.size.lineHeight,
        fontSize: constants.size.denseFullWidth.fontSize
      }
    },

    bordered: {
      borderWidth: 1,
      borderRadius: _reactackleCore.radiusDefault
    },

    underlined: {
      borderWidth: 2,
      borderRadius: 0
    }
  },

  placeholder: {
    fontColor: _reactackleCore.colorPaletteGrey400
  },

  label: {
    positionTop: {
      fontSize: _reactackleCore.fontSizeSmall,
      lineHeight: 1,
      textTransform: 'none',
      fontWeight: _reactackleCore.fontWeightNormal,

      style: {
        fontColor: _reactackleCore.fontColorMedium,

        disabled: {
          fontColor: _reactackleCore.fontColorMedium
        },

        focus: {
          fontColor: constants.themeColor
        },

        error: {
          fontColor: _reactackleCore.colorError
        },

        success: {
          fontColor: _reactackleCore.colorSuccess
        }
      },

      size: {
        bordered: {
          paddingTop: 0,
          labelSpacing: (0, _reactackleCore.bmodule)(1),

          dense: {
            paddingTop: 0,
            labelSpacing: (0, _reactackleCore.bmodule)(0.5)
          },

          fullWidth: {
            paddingTop: (0, _reactackleCore.bmodule)(0.5),
            labelSpacing: (0, _reactackleCore.bmodule)(0.5)
          },

          denseFullWidth: {
            paddingTop: (0, _reactackleCore.bmodule)(0.5),
            labelSpacing: (0, _reactackleCore.bmodule)(0.5)
          }
        },

        underlined: {
          paddingTop: 0,
          labelSpacing: 0,

          dense: {
            paddingTop: 0,
            labelSpacing: (0, _reactackleCore.bmodule)(0.5)
          },

          fullWidth: {
            paddingTop: (0, _reactackleCore.bmodule)(0.5),
            labelSpacing: (0, _reactackleCore.bmodule)(0.5)
          },

          denseFullWidth: {
            paddingTop: (0, _reactackleCore.bmodule)(0.5),
            labelSpacing: (0, _reactackleCore.bmodule)(0.5)
          }
        }
      }
    },

    positionSide: {
      fontSize: _reactackleCore.fontSizeBody,
      lineHeight: _reactackleCore.bodyLineHeight,
      textTransform: 'none',
      fontWeight: _reactackleCore.fontWeightNormal,
      width: '30%',

      style: {
        fontColor: _reactackleCore.bodyFontColor,

        disabled: {
          fontColor: _reactackleCore.fontColorMedium
        },

        focus: {
          fontColor: constants.themeColor
        },

        error: {
          fontColor: _reactackleCore.colorError
        },

        success: {
          fontColor: _reactackleCore.colorSuccess
        }
      },

      size: {
        bordered: {
          paddingTop: 0,
          paddingBottom: 0,
          labelSpacing: (0, _reactackleCore.bmodule)(1),

          dense: {
            paddingTop: 0,
            paddingBottom: 0,
            labelSpacing: (0, _reactackleCore.bmodule)(1)
          },

          fullWidth: {
            paddingTop: (0, _reactackleCore.bmodule)(0.5),
            paddingBottom: (0, _reactackleCore.bmodule)(0.5),
            labelSpacing: (0, _reactackleCore.bmodule)(1)
          },

          denseFullWidth: {
            paddingTop: (0, _reactackleCore.bmodule)(0.5),
            paddingBottom: (0, _reactackleCore.bmodule)(0.5),
            labelSpacing: (0, _reactackleCore.bmodule)(1)
          }
        },

        underlined: {
          paddingTop: 0,
          paddingBottom: 0,
          labelSpacing: (0, _reactackleCore.bmodule)(1),

          dense: {
            paddingTop: 0,
            paddingBottom: 0,
            labelSpacing: (0, _reactackleCore.bmodule)(1)
          },

          fullWidth: {
            paddingTop: (0, _reactackleCore.bmodule)(0.5),
            paddingBottom: (0, _reactackleCore.bmodule)(0.5),
            labelSpacing: (0, _reactackleCore.bmodule)(1)
          },

          denseFullWidth: {
            paddingTop: (0, _reactackleCore.bmodule)(0.5),
            paddingBottom: (0, _reactackleCore.bmodule)(0.5),
            labelSpacing: (0, _reactackleCore.bmodule)(1)
          }
        }
      },

      breakpoints: [{
        breakpoint: _reactackleCore.breakpointMedium,
        width: 150
      }]
    },

    labelTooltipSpacing: (0, _reactackleCore.bmodule)(1)
  },

  iconOuter: {
    iconSpacing: (0, _reactackleCore.bmodule)(1),

    state: {
      color: 'inherit',
      opacity: constants.iconOuter.opacity,

      disabled: {
        color: 'inherit',
        opacity: 0.25
      },

      focus: {
        color: constants.themeColor,
        opacity: constants.iconOuter.opacity
      },

      error: {
        color: 'inherit',
        opacity: constants.iconOuter.opacity
      },

      success: {
        color: 'inherit',
        opacity: constants.iconOuter.opacity
      }
    },

    size: {
      boxSize: function boxSize(base) {
        return constants.size.fontSize(base) * constants.size.lineHeight + constants.size.paddingY(base) * 2;
      },
      imgSize: null,

      dense: {
        boxSize: function boxSize(base) {
          return constants.size.dense.fontSize(base) * constants.size.dense.lineHeight + constants.size.dense.paddingY(base) * 2;
        },
        imgSize: null
      },

      fullWidth: {
        boxSize: function boxSize(base) {
          return constants.size.fullWidth.fontSize(base) * constants.size.fullWidth.lineHeight + constants.size.fullWidth.paddingY(base) * 2;
        },
        imgSize: null
      },

      denseFullWidth: {
        boxSize: function boxSize(base) {
          return constants.size.denseFullWidth.fontSize(base) * constants.size.denseFullWidth.lineHeight + constants.size.denseFullWidth.paddingY(base) * 2;
        },
        imgSize: null
      }
    }
  },

  iconInner: {
    iconSpacing: (0, _reactackleCore.bmodule)(0.5),

    state: {
      color: 'inherit',
      opacity: constants.iconInner.opacity,

      disabled: {
        color: 'inherit',
        opacity: 0.35
      },

      hover: {
        color: 'inherit',
        opacity: 0.8
      },

      focus: {
        color: 'inherit',
        opacity: 1
      },

      error: {
        color: 'inherit',
        opacity: constants.iconInner.opacity
      },

      success: {
        color: 'inherit',
        opacity: constants.iconInner.opacity
      }
    },

    size: {
      boxSize: function boxSize(base) {
        return constants.size.fontSize(base) * constants.size.lineHeight + constants.size.paddingY(base) * 2;
      },
      imgSize: null,

      dense: {
        boxSize: function boxSize(base) {
          return constants.size.dense.fontSize(base) * constants.size.dense.lineHeight + constants.size.dense.paddingY(base) * 2;
        },
        imgSize: null
      },

      fullWidth: {
        boxSize: function boxSize(base) {
          return constants.size.fullWidth.fontSize(base) * constants.size.fullWidth.lineHeight + constants.size.fullWidth.paddingY(base) * 2;
        },
        imgSize: null
      },

      denseFullWidth: {
        boxSize: function boxSize(base) {
          return constants.size.denseFullWidth.fontSize(base) * constants.size.denseFullWidth.lineHeight + constants.size.denseFullWidth.paddingY(base) * 2;
        },
        imgSize: null
      }
    }
  },

  buttonInner: {
    iconSpacing: (0, _reactackleCore.bmodule)(0.5),

    state: {
      color: constants.fontColor,
      opacity: constants.iconInner.opacity,

      disabled: {
        color: 'inherit',
        opacity: 0.35
      },

      hover: {
        color: constants.fontColor,
        opacity: 0.8
      },

      focus: {
        color: constants.fontColor,
        opacity: 1
      },

      error: {
        color: constants.fontColor,
        opacity: constants.iconInner.opacity
      },

      success: {
        color: constants.fontColor,
        opacity: constants.iconInner.opacity
      }
    },

    size: {
      boxSize: function boxSize(base) {
        return constants.size.fontSize(base) * constants.size.lineHeight + constants.size.paddingY(base) * 2;
      },
      imgSize: 24,

      dense: {
        boxSize: function boxSize(base) {
          return constants.size.dense.fontSize(base) * constants.size.dense.lineHeight + constants.size.dense.paddingY(base) * 2;
        },
        imgSize: 24
      },

      fullWidth: {
        boxSize: function boxSize(base) {
          return constants.size.fullWidth.fontSize(base) * constants.size.fullWidth.lineHeight + constants.size.fullWidth.paddingY(base) * 2;
        },
        imgSize: 24
      },

      denseFullWidth: {
        boxSize: function boxSize(base) {
          return constants.size.denseFullWidth.fontSize(base) * constants.size.denseFullWidth.lineHeight + constants.size.denseFullWidth.paddingY(base) * 2;
        },
        imgSize: 24
      }
    }
  },
  clearingIconElement: _react2.default.createElement(_reactackleIcons.IconCross, { size: 'custom', color: 'inherit' }),
  passwordIconShowElement: _react2.default.createElement(_reactackleIcons.IconEye, { size: 'custom', color: 'inherit' }),
  passwordIconHideElement: _react2.default.createElement(_reactackleIcons.IconEyeClosed, { size: 'custom', color: 'inherit' }),

  message: {
    messageSpacing: (0, _reactackleCore.bmodule)(1),
    fontSize: _reactackleCore.fontSizeSmall,
    lineHeight: 1,

    style: {
      fontColor: _reactackleCore.fontColorMedium,

      disabled: {
        fontColor: _reactackleCore.fontColorMedium
      },

      focus: {
        fontColor: _reactackleCore.fontColorMedium
      },

      error: {
        fontColor: _reactackleCore.colorAlert
      },

      success: {
        fontColor: _reactackleCore.colorSuccess
      }
    }
  },

  symbolCounter: {
    counterSpacing: (0, _reactackleCore.bmodule)(1),
    counterMessageSpacing: (0, _reactackleCore.bmodule)(4),
    fontSize: _reactackleCore.fontSizeSmall,
    lineHeight: 1,

    style: {
      fontColor: _reactackleCore.fontColorMedium,

      disabled: {
        fontColor: _reactackleCore.fontColorMedium
      },

      focus: {
        fontColor: _reactackleCore.fontColorMedium
      },

      error: {
        fontColor: _reactackleCore.colorAlert
      }
    }
  },

  prefix: {
    lineHeight: 'inherit',

    size: {
      fontSize: 'inherit',
      paddingY: (0, _reactackleCore.bmodule)(0.5),
      prefixSpacing: (0, _reactackleCore.bmodule)(2),
      prefixEdgeSpacing: {
        bordered: (0, _reactackleCore.bmodule)(1),
        underlined: 0
      },

      dense: {
        fontSize: 'inherit',
        paddingY: (0, _reactackleCore.bmodule)(0.5),
        prefixSpacing: (0, _reactackleCore.bmodule)(2),
        prefixEdgeSpacing: {
          bordered: (0, _reactackleCore.bmodule)(1),
          underlined: 0
        }
      },

      fullWidth: {
        fontSize: 'inherit',
        paddingY: (0, _reactackleCore.bmodule)(0.5),
        prefixSpacing: (0, _reactackleCore.bmodule)(2),
        prefixEdgeSpacing: {
          bordered: (0, _reactackleCore.bmodule)(1),
          underlined: 0
        }
      },

      denseFullWidth: {
        fontSize: 'inherit',
        paddingY: (0, _reactackleCore.bmodule)(0.5),
        prefixSpacing: (0, _reactackleCore.bmodule)(2),
        prefixEdgeSpacing: {
          bordered: (0, _reactackleCore.bmodule)(1),
          underlined: 0
        }
      }
    },

    state: {
      bordered: {
        fontColor: _reactackleCore.fontColorMedium,
        backgroundColor: 'inherit',

        focus: {
          fontColor: constants.fontColor,
          backgroundColor: constants.backgroundColor
        },

        disabled: {
          fontColor: _reactackleCore.fontColorMedium,
          backgroundColor: _reactackleCore.colorTransparent
        },

        error: {
          fontColor: _reactackleCore.colorAlert,
          backgroundColor: constants.backgroundColor
        },

        success: {
          fontColor: _reactackleCore.colorSuccess,
          backgroundColor: constants.backgroundColor
        }
      },

      underlined: {
        fontColor: _reactackleCore.fontColorMedium,
        backgroundColor: 'inherit',

        focus: {
          fontColor: constants.fontColor,
          backgroundColor: constants.backgroundColor
        },

        disabled: {
          fontColor: _reactackleCore.fontColorMedium,
          backgroundColor: _reactackleCore.colorTransparent
        },

        error: {
          fontColor: _reactackleCore.colorAlert,
          backgroundColor: constants.backgroundColor
        },

        success: {
          fontColor: _reactackleCore.colorSuccess,
          backgroundColor: constants.backgroundColor
        }
      }
    }
  },

  postfix: {
    lineHeight: 'inherit',

    size: {
      fontSize: 'inherit',
      paddingY: (0, _reactackleCore.bmodule)(0.5),
      postfixSpacing: (0, _reactackleCore.bmodule)(2),
      postfixEdgeSpacing: {
        bordered: (0, _reactackleCore.bmodule)(1),
        underlined: 0
      },

      dense: {
        fontSize: 'inherit',
        paddingY: (0, _reactackleCore.bmodule)(0.5),
        postfixSpacing: (0, _reactackleCore.bmodule)(2),
        postfixEdgeSpacing: {
          bordered: (0, _reactackleCore.bmodule)(1),
          underlined: 0
        }
      },

      fullWidth: {
        fontSize: 'inherit',
        paddingY: (0, _reactackleCore.bmodule)(0.5),
        postfixSpacing: (0, _reactackleCore.bmodule)(2),
        postfixEdgeSpacing: {
          bordered: (0, _reactackleCore.bmodule)(1),
          underlined: 0
        }
      },

      denseFullWidth: {
        fontSize: 'inherit',
        paddingY: (0, _reactackleCore.bmodule)(0.5),
        postfixSpacing: (0, _reactackleCore.bmodule)(2),
        postfixEdgeSpacing: {
          bordered: (0, _reactackleCore.bmodule)(1),
          underlined: 0
        }
      }
    },

    state: {
      bordered: {
        fontColor: _reactackleCore.fontColorMedium,
        backgroundColor: 'inherit',

        focus: {
          fontColor: constants.fontColor,
          backgroundColor: constants.backgroundColor
        },

        disabled: {
          fontColor: _reactackleCore.fontColorMedium,
          backgroundColor: _reactackleCore.colorTransparent
        },

        error: {
          fontColor: _reactackleCore.colorAlert,
          backgroundColor: constants.backgroundColor
        },

        success: {
          fontColor: _reactackleCore.colorSuccess,
          backgroundColor: constants.backgroundColor
        }
      },

      underlined: {
        fontColor: _reactackleCore.fontColorMedium,
        backgroundColor: 'inherit',

        focus: {
          fontColor: constants.fontColor,
          backgroundColor: constants.backgroundColor
        },

        disabled: {
          fontColor: _reactackleCore.fontColorMedium,
          backgroundColor: _reactackleCore.colorTransparent
        },

        error: {
          fontColor: _reactackleCore.colorAlert,
          backgroundColor: constants.backgroundColor
        },

        success: {
          fontColor: _reactackleCore.colorSuccess,
          backgroundColor: constants.backgroundColor
        }
      }
    }
  }
};


//////////////////
// WEBPACK FOOTER
// ./~/reactackle-text-field/dist/styles/theme.js
// module id = 855
// module chunks = 0